import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';

// SERVICES
import { RolesService } from 'src/app/services/roles.service';
import { GrupoService } from 'src/app/services/grupos.service';
import {HelpersService} from 'src/app/services/helpers.service';

@Component({
  selector: 'app-editar-usuario',
  templateUrl: './editar-usuario.component.html',
  styleUrls: ['./editar-usuario.component.scss'],
})
export class EditarUsuarioComponent implements OnInit {
  editarClave:boolean=false;
  roles;
  grupos;
  usuarioForm = this.fb.group({
    clave: [''],
    claveDeshabilitada:[{value:'',disabled:true}],
    id_usuarios: [''],
    correo: ['', [Validators.required, Validators.email, Validators.max(30)]],
    nombre: ['', [Validators.required]],
    apellido: ['', [Validators.required]],
    telefono: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    documento: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    estatus: ['Activo'],
    nombre_equipo: ['', [Validators.required]],
    nm: ['', [Validators.required]],
    intentos: [0],
    borrado: [0],
    id_grupos: [''],
    id_roles: ['', [Validators.required]],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });

  constructor(
    public dialogRef: MatDialogRef<EditarUsuarioComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public userService: UserService,
    private rolesService: RolesService,
    private gruposService: GrupoService,
    public helpers: HelpersService
  ) {
    this.setInfo();
    this.rolesService.getRoles().subscribe((data: any) => {
      console.log("Obteniendo roles",data.payload);
      this.roles = data.payload;
    });
    this.gruposService.obtenerTodos().subscribe((data: any) => {
      console.log("Obteniendo grupos",data.payload);
      this.grupos = data.payload;
    });
  }

  ngOnInit(): void {}

  setInfo() {
    this.usuarioForm.controls.id_usuarios.setValue(this.data.id_usuarios);
    this.usuarioForm.controls.correo.setValue(this.data.correo);
    this.usuarioForm.controls.nombre.setValue(this.data.nombre);
    this.usuarioForm.controls.apellido.setValue(this.data.apellido);
    this.usuarioForm.controls.telefono.setValue(this.data.telefono);
    this.usuarioForm.controls.documento.setValue(this.data.documento);
    this.usuarioForm.controls.estatus.setValue(this.data.estatus);
    this.usuarioForm.controls.nombre_equipo.setValue(this.data.nombre_equipo);
    this.usuarioForm.controls.nm.setValue(this.data.nm);
    this.usuarioForm.controls.intentos.setValue(this.data.intentos);
    this.usuarioForm.controls.borrado.setValue(this.data.borrado);
    this.usuarioForm.controls.id_roles.setValue(this.data.id_roles);
    this.usuarioForm.controls.correo.setValue(this.data.correo);
    this.usuarioForm.controls.id_grupos.setValue(this.data.id_grupos);
    // this.usuarioForm.controls.intentos.setValue(this.data.clave);
  }

  save(){
    console.log("Enviando formulario",this.usuarioForm.value)
    this.userService.updateUser(this.usuarioForm.value.id_usuarios, this.usuarioForm.value)
      .subscribe( (response)=>{
        console.log("Respuesta al 'editar usuario'",response.payload)
        this.helpers.snackbar("Usuario actualizado con éxito.")
        this.dialogRef.close(true)
      },err=>{
        console.log("ERROR al editar un usuario",err.error.payload)
        this.helpers.snackbar(err.error.payload)
      })
  }
}
